import { isTikTokAdTraffic } from './eventTracking.js'
import { parseSiteConfigData } from './siteSeo.js'
import { shouldReportPlatformPixel } from './pixelDomainPolicy.js'

export const TIKTOK_ADS_ONLY_TRACKING_CONFIG_KEY = 'tiktokAdsOnlyTracking'

export function isTikTokAdsOnlyTrackingEnabled(configData) {
  const value = parseSiteConfigData(configData)?.[TIKTOK_ADS_ONLY_TRACKING_CONFIG_KEY]
  return value === true || value === 1 || (typeof value === 'string' && ['1', 'true'].includes(value.trim().toLowerCase()))
}

export function shouldReportTikTokTracking(configData) {
  if (!shouldReportPlatformPixel(configData, 'tiktok')) {
    return false
  }

  return !isTikTokAdsOnlyTrackingEnabled(configData) || isTikTokAdTraffic()
}
